import React, { Component } from 'react';
import { BasicSetup } from 'Components/basicsetup/BasicSetup';

class UserRoles extends Component {
  render() {
    return (
      <BasicSetup
        resourcename={'role'}
        humanname={'User Role'}
        blockEditFromId={1}
        blockEditToId={1}
        {...this.props}
      />
    );
  }
}

export { UserRoles };



// WEBPACK FOOTER //
// ./src/pages/userroles/UserRoles.js